<template>
    <transition name="tips-fade">
        <div class="alert" v-show="showFlag" :style="tipsStyle">
            {{content}}
        </div>
    </transition>
</template>
<script>
    // <tips :show-flag="showTips" :content="tipsContent" @hidetips="showTips=false"></tips>
    export default {
        data() {
            return {}
        },
        props: ['showFlag', 'content', 'showTime', 'tipsStyle'],
        watch: {
            showFlag() {
                if (this.showFlag) {
                    this.hide();
                }
            }
        },
        methods: {
            hide() {
                let time = this.showTime || 2000; // 停留时间
                clearTimeout(timer);
                let timer = setTimeout(() => {
                    this.$emit('hidetips');
                }, time);
            }
        }
    }
</script>
<style lang="less">
    .alert {
        position: fixed;
        left: 50%;
        top: 50%;
        line-height: 18px;
        z-index: 9999999;
        font-size: 12px;
        background-color: rgba(0, 0, 0, .8);
        border-radius: 9px;
        color: #ffffff;
        text-align: center;
        padding: 10px;
        white-space: nowrap;
        transform: translate3d(-50%, -50%, 0);
    }

    .tips-fade-enter, .tips-fade-leave-active {
        opacity: 0;
        top: 55%;
    }

    .tips-fade-enter-active, .tips-fade-leave-active {
        transition: all .25s linear;
    }
</style>
